import { Breadcrumb, Card } from "antd";
import { useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../assests/images/loanBread.svg";
import LoanAccountsList from "../accounts/components/loanList";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function Loans() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <>
        {/* <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.my_accounts.common_my_accounts.loans", {
                defaultValue: "Investment",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb> */}

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.my_accounts.common_my_accounts.loans", {
                defaultValue: "Investment",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <Card className="dashboard-accounts-body">
          <LoanAccountsList />
        </Card>
      </div>
    </>
  );
}
